/** @jsx jsx */
import { Fragment } from 'react'
import { navigate } from 'gatsby'
import { Button, jsx, Text } from 'theme-ui'
import Stars from '~/components/Reviews/Stars'
import { useReviews } from '~/hooks/components/use-reviews'
import { roundReviewScore } from '~/utils/formatters'

const LinkedReviewStars = ({ id, hideIfLessThan = 3, mb, mt, to }) => {
  const { getProductStats, getSiteStats } = useReviews()
  const reviewStats = id ? getProductStats(id) : getSiteStats()

  if (!reviewStats?.count || reviewStats.count < hideIfLessThan) {
    return <Fragment />
  }

  const count = reviewStats.count
  const score = reviewStats.score

  const handleClick = () => {
    const fullReviews = document.getElementById('reviews')

    if (to) {
      navigate(to)
    } else if (fullReviews) {
      fullReviews.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      })
    }
  }

  return (
    <Button
      aria-label={`Average review of ${roundReviewScore(
        score,
        'half'
      )} from ${count} reviews`}
      onClick={(e) => handleClick()}
      variant="reset"
      sx={{
        alignItems: 'center',
        cursor: 'pointer',
        display: 'flex',
        width: 'fit-content',
      }}
      mt={mt}
      mb={mb}
    >
      <Text as="span" mr="-3px" sx={{ lineHeight: '18px' }}>
        <Stars score={score} />
      </Text>
      <Text
        as="span"
        variant="body3"
        ml={1}
        sx={{
          color: 'brandPrimary',
          lineHeight: '18px',
          position: 'relative',
          textDecoration: 'underline',
          top: '-1px',
        }}
      >
        {`${reviewStats.count} review${reviewStats.count > 1 ? 's' : ''}`}
      </Text>
    </Button>
  )
}

export default LinkedReviewStars
